import ComponentHelper from '../../../supers/ComponentHelper';
import Modal from 'react-modal';
import React from 'react';
import './create-definition-modal.css';
import InputField from '../../../components/input-field/InputField';
import ValidationService from '../../../services/ValidationService';
import Spinner from '../../../components/spinner/Spinner';
import RESTService from '../../../services/RESTService';
const VS = new ValidationService();
const connect = new RESTService();

class CreateDefinitionModal extends ComponentHelper {
	constructor(props) {
		super(props);
		this.setInitialData(props);
	}

	setInitialData = props => {
		this.data = {
			title: 'New Definition',
			name: '',
			version: '',
			displayName: '',
			saving: false,
			errorMessage: null
		};
	};

	// Clear component state when modal is re-open
	componentWillReceiveProps(nextProps) {
		if (!this.props.isOpen && nextProps.isOpen) {
			this.observe(() => {
				this.setInitialData(nextProps);
			});
		}
	}

	isValidInput() {
		let { name, version, displayName } = this.data;
		return name.length > 0 && name.length <= 15 && version.length > 0 && displayName.length > 0;
	}

	clearError = () => {
		this.setData('errorMessage', null);
	};

	onNameChange = evt => {
		this.observe(() => {
			if (VS.validateName(evt.target.value)) {
				this.data[evt.target.name] = evt.target.value;
			}
		});
	};

	onBasicChange = evt => {
		if (evt.target.name === 'version' && !VS.validateName(evt.target.value)) {
			return;
		}
		this.setData(evt.target.name, evt.target.value);
	};

	onCreate = () => {
		this.setData('saving', true);
		let { name, version, displayName } = this.data;
		connect
			.saveAppDef({
				name: name,
				version: version,
				displayName: displayName,
				security: {},
				theme: {},
				dashboard: {},
				shared: {},
				modules: {}
			})
			.then(res => {
				this.props.onComplete(res.data);
			})
			.catch(err => {
				this.observe(() => {
					this.data.saving = false;
					this.data.errorMessage = err.response.data.message;
				});
			});
	};

	render() {
		let { isOpen } = this.props;
		let { title, saving, name, version, displayName, errorMessage } = this.data;
		return (
			<Modal
				contentLabel="Modal"
				ariaHideApp={false}
				isOpen={isOpen}
				className="create-definition-modal animated zoomIn"
				overlayClassName="dialog-modal-overlay vbox hcenter vcenter"
			>
				<div className="modal-header">{title}</div>
				{saving ? (
					<Spinner text="Saving..." height="267px" />
				) : errorMessage === null ? (
					<div className="modal-body">
						<InputField
							label="Application Name"
							name="name"
							type="text"
							value={name}
							handleChange={this.onNameChange}
							placeholder="Enter a unique name"
							subText="Use only lowercase characters, numbers or hyphens."
							required
							autoFocus
						/>
						<InputField
							label="Version"
							name="version"
							type="text"
							value={version}
							handleChange={this.onBasicChange}
							placeholder="Enter a definition version"
							subText="Use only lowercase characters, numbers or hyphens."
							required
						/>
						<InputField
							label="Display Name"
							name="displayName"
							type="text"
							value={displayName}
							handleChange={this.onBasicChange}
							placeholder="Enter a definition display name"
							required
						/>
					</div>
				) : (
					<div className="error-message-body vbox vcenter hcenter">{errorMessage}</div>
				)}
				<div className="btn-ctn">
					<button className="btn cancel-btn" onClick={this.props.onClose} disabled={saving}>
						Cancel
					</button>
					<button className="btn primary" onClick={errorMessage ? this.clearError : this.onCreate} disabled={!this.isValidInput() || saving}>
						{errorMessage ? 'Ok' : 'Create'}
					</button>
				</div>
			</Modal>
		);
	}
}
export default CreateDefinitionModal;



// WEBPACK FOOTER //
// ./src/views/application-builder/create-definition-modal/CreateDefinitionModal.js